import React from 'react';
import PropTypes from 'prop-types';

import { ButtonTypes } from 'components/common/button';
import CloseModal from 'actions/modal/close_modal';
import ConfirmOrCancelModal from 'components/common/confirm_or_cancel_modal';
import connect from 'components/lib/connect';
import RedactTaskComment from 'actions/task/redact_task_comment';

function TaskCommentRedactModal(props) {
  const onSubmit = () => {
    props.onConfirm({ itemId: props.itemId, commentId: props.commentId });
  };

  return <ConfirmOrCancelModal {...props} onSubmit={onSubmit} />;
}

TaskCommentRedactModal.propTypes = {
  commentId: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

function mapStateToProps({ getProvider }) {
  const modalAttrs = getProvider('modal').get();

  return {
    commentId: modalAttrs.commentId,
    itemId: modalAttrs.itemId,
    submitButtonType: ButtonTypes.DANGER,
    submitText: 'Delete comment',
    text: 'Are you sure you want to delete this comment? This cannot be undone.',
    title: 'Delete comment',
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onCancel: () => {
      executeAction(CloseModal);
    },
    onConfirm: props => {
      executeAction(RedactTaskComment, props);
    },
  };
}

export default connect(mapStateToProps, mapExecuteToProps)(TaskCommentRedactModal);
